/**
 * Decode common HTML entities in attribute/text values extracted from HTML source.
 * Named entities that expand to `&` must run last so sequences like `&amp;lt;` stay correct.
 */
export function decodeHtmlEntities(content: string): string {
    return content
        .replace(/&nbsp;/gi, ' ')
        .replace(/&#x([0-9a-f]+);/gi, (_match, code: string) => String.fromCharCode(parseInt(code, 16)))
        .replace(/&#(\d+);/g, (_match, code: string) => String.fromCharCode(Number(code)))
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&amp;/gi, '&')
}
